import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { Partner, Signup } from '@app/_models';
import { AlertService, SignupService } from '@app/_services';
import { FadvStepComponent, FadvStepperComponent } from '@fa-switch-sharedservices/ng-elements';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.css']
})
export class PartnerComponent implements OnInit {

  @ViewChild('partnerStepper') partnerStepper!: FadvStepperComponent;
  @ViewChild('startStep') startStep!: FadvStepComponent;
  @ViewChild('packageStep') packageStep!: FadvStepComponent;
  @ViewChild('candidateStep') candidateStep!: FadvStepComponent;
  @ViewChild('paymentStep') paymentStep!: FadvStepComponent;
  @ViewChild('accountStep') accountStep!: FadvStepComponent;
  @ViewChild('credentialingStep') credentialingStep!: FadvStepComponent;

  stepperPosition: string;
  hideStepper: boolean = false;
  innerWidth: number = window.innerWidth;
  currentStep: number;
  loading: boolean = true;
  mobile: boolean = false;
  success: boolean = false;
  signup: Signup;
  path: string;


  constructor(private router: Router,
    private signupService: SignupService) {}

  ngOnInit(): void {
    this.loading = true;
    this.handleStepper(this.hideStepper);
  }

  ngAfterViewInit(): void {
    this.handleViewChange();
    this.currentStep = 0;
  }

  @HostListener('window:resize', ['$event'])
  handleViewChange() {

    this.innerWidth = window.innerWidth;

    if (this.innerWidth <= 768) {
      this.mobile = true;
      this.stepperPosition = "horizontal";
    }
    else {
      this.mobile = false;
      this.stepperPosition = "vertical";
    }
  }

  start() {
    this.router.navigate(["/partner/error"]);
  }

  handleStepper(hide: boolean): void {
    if (hide) {
      this.hideStepper = true;
    }
    else {
      this.hideStepper = false;
    }
  }

  stepActivatedCallBack(step: FadvStepComponent) {

    switch (step['index']) {
      case 0:
        this.signup = this.signupService.getSignup();
        var path = '/partner/start/' + this.signup.partner.token;
        this.hideStepper = false;
        this.router.navigate([path]);
        break;
      case 1:
        this.hideStepper = false;
        this.router.navigate(['/partner/package']);
        break;
      case 2:
        this.hideStepper = false;
        this.router.navigate(['/partner/candidate']);
        break;
      case 3:
        this.hideStepper = false;
        this.router.navigate(['/partner/payment']);
        break;
      case 4:
        this.hideStepper = false;
        this.router.navigate(['/partner/account']);
        break;
      case 5:
        this.hideStepper = true;
        this.router.navigate(['/partner/credentialing']);
        break;

      default:

        break;
    }
  }

  setStep(path: string) {
    //this component is being called in by other components which causes issues with multiple onInit/AfterViewInit calls
    //adding a clause at the top to check for undefined and then return if so, allowing the calling components to finish lifecycles until properties have been defined.
    //removing this will allow the stepper to function *mostly* normally, however it will consistently throw errors into the console on refresh
    this.handleViewChange();
    if (this.partnerStepper == undefined) {
      return;
    }
    switch (path) {
      case "/partner/start":
        this.currentStep = 0;
        this.hideStepper = false;
        this.partnerStepper.gotoStep(0);
        break;
      case "/partner/package":
        this.currentStep = 1;
        this.hideStepper = false;
        this.partnerStepper.gotoStep(1);
        break;
      case "/partner/candidate":
        this.currentStep = 2;
        this.hideStepper = false;
        this.partnerStepper.gotoStep(2);
        break;
      case "/partner/invite":
        this.currentStep = 2;
        this.hideStepper = false;
        this.partnerStepper.gotoStep(2);
        break;
      case "/partner/online":
        this.currentStep = 2;
        this.hideStepper = false;
        this.partnerStepper.gotoStep(2);
        break;
      case "/partner/payment":
        this.currentStep = 3;
        this.hideStepper = false;
        this.partnerStepper.gotoStep(3);
        break;
      case "/partner/account":
        this.currentStep = 4;
        this.hideStepper = false;
        this.partnerStepper.gotoStep(4);
        break;
      case "/partner/credentialing":
        this.currentStep = 5;
        this.hideStepper = true;
        this.partnerStepper.gotoStep(5);
        break;
      default:
        break;
    }
  }
}